import * as yup from 'yup';

import { REQUIRED } from '../../forms/errorsText.js';
import SettingsPresenter from '../../presenters/store/invoice/SettingsPresenter';

export const validationFields = {
  contactPerson: yup.string().required(REQUIRED),
  contactEmail: yup.string().required(REQUIRED),
  contactPhoneNumber: yup.string().required(REQUIRED),
  wiringInstructions: yup.string(),
};

export const validationSchema = yup.object().shape({ ...validationFields });

export const initialValues = (settings) => {
  return {
    contactPerson: SettingsPresenter.contactPerson(settings) || '',
    contactEmail: SettingsPresenter.contactEmail(settings) || '',
    contactPhoneNumber: SettingsPresenter.contactPhoneNumber(settings) || '',
    wiringInstructions: SettingsPresenter.wiringInstructions(settings) || '',
  };
};
